import React, { useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";

import "./style.scss";
import { Input, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import authStore from "../../../stores/authStore";
import articleStore from "../../../stores/articleStore";
import { triggerLogin } from "../../../utils/trigger";
import logoIcon from "../../../images/logo.png";
import houseIcon from "../../../images/house.png";
import vipIcon from "../../../images/vip-icon.png";
import syncedLogoIcon from "../../../images/synced-logo.png";
import searchIcon from "../../../images/search-input.png";
import jewelImg from "../../../images/jewel-icon.png";
import noUserIcon from "../../../images/no-user.png";
import { isMobile } from "../../../utils/tools";

const ArticleNav: React.FC = () => {
  // const history = useHistory();
  const { id } = useParams();
  const inputRef = useRef(null);
  const { currentUser, isLogin, isMember, memberInfo, setDialog } = useContext(
    authStore
  );
  const {
    params,
    list,
    fetchList,
    nextPage,
    revert,
    keyword,
    setKeyword,
    showList,
    setShowList,
  } = useContext(articleStore);

  // useEffect(() => {
  //   setTimeout(() => {
  //     fetchMemberInfo();
  //   }, 500);
  // }, []);
  useEffect(() => {
    // 列表页 || 空降详情下，清空数据、请求列表
    if (!id || (id && params.page === 1 && list.length < 1)) {
      revert();
      fetchList(keyword);
    } else if (id && list.length > 0) {
      // 有滚动置顶效果时，防止下方无数据滚不上来，多请求一页数据
      nextPage(keyword);
    }
  }, []);

  return (
    <>
      <div className="article-nav">
        <div className="article-nav__main">
          {isMobile() && (
            <img
              className="article-nav__home"
              src={houseIcon}
              alt="home"
              onClick={() => window.open("/", "_black")}
            />
          )}
          <div className="logo-area">
            {!isMobile() && (
              <img
                className="logo-home"
                src={syncedLogoIcon}
                alt="home"
                onClick={() => window.open("/", "_black")}
              />
            )}
            <div
              className="title"
              onClick={() => window.open("/articles", "_self")}
            >
              <img className="logo" src={logoIcon} alt="logo" />
              {isMobile() ? "机器之心 · 文章库" : "文章库"}
            </div>
            {!isMobile() && (
              <div className="search-wrapper">
                <Input
                  prefix={<img src={searchIcon} alt="icon" />}
                  allowClear
                  placeholder="探索机器之心文章库"
                  defaultValue={keyword}
                  disabled={!isLogin || !isMember}
                  onChange={(e: React.BaseSyntheticEvent) => {
                    if (e.target.value === "") {
                      setKeyword("");
                      fetchList();
                    }
                  }}
                  onPressEnter={(e: React.BaseSyntheticEvent) => {
                    !showList && setShowList(true);
                    setKeyword(e.target.value);
                    fetchList(e.target.value);
                  }}
                />
                {(!isLogin || !isMember) && (
                  <div
                    className="search-blank"
                    onClick={() => {
                      if (isLogin) {
                        message.warning({
                          content: "请先订阅文章库，方可解锁检索功能",
                          icon: <ExclamationCircleFilled style={{ color: "#faad14" }} />,
                        });
                      } else {
                        triggerLogin();
                      }
                    }}
                  />
                )}
              </div>
            )}
          </div>
          <div className="user-area__avatar">
            {isLogin ? (
              <div className="user-area__fill">
                {!isMobile() && !isMember && (
                  <div
                    className="user-area__btn"
                    onClick={() => setDialog("buyVip", true)}
                  >
                    <img src={vipIcon} alt="icon" />
                    订阅文章库
                  </div>
                )}
                <div className="user-area__my-info">
                  <div
                    className={`user-area__my-avatar ${isMember &&
                      "user-area__my-avatar--member"}`}
                  >
                    <img
                      className="avatar"
                      src={currentUser.avatar_url}
                      alt={currentUser.name}
                    />
                    {isMember && (
                      <img className="icon" src={jewelImg} alt="jewel" />
                    )}
                  </div>
                  <span>
                    {isMobile() ? "" : currentUser.nickname || currentUser.name}
                  </span>
                </div>
                {!isMobile() && isMember && (
                  <div className="user-area__my-time">
                    {memberInfo && memberInfo.articleExpiredAt && (
                      <div>
                        订阅到期时间：
                        {memberInfo && memberInfo.articleExpiredAt}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="btn__no-user" onClick={() => triggerLogin()}>
                <img src={noUserIcon} alt="no-user" />
                登录
              </div>
            )}
          </div>
        </div>
        {isMobile() && !id && (
          <div className="article-nav__search">
            <Input
              ref={inputRef}
              prefix={<img src={searchIcon} alt="icon" />}
              allowClear
              placeholder="探索机器之心文章库"
              defaultValue={keyword}
              onChange={(e: React.BaseSyntheticEvent) => {
                if (e.target.value === "") {
                  setKeyword("");
                  fetchList();
                }
              }}
              onPressEnter={(e: React.BaseSyntheticEvent) => {
                setKeyword(e.target.value);
                fetchList(e.target.value);
                inputRef.current.blur();
              }}
            />
            {(!isLogin || !isMember) && (
              <div
                className="search-blank"
                onClick={() => {
                  if (isLogin) {
                    message.warning({
                      content: "请先订阅文章库，方可解锁检索功能",
                      icon: <ExclamationCircleFilled style={{ color: "#faad14" }} />,
                    });
                  } else {
                    triggerLogin();
                  }
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default observer(ArticleNav);
